import { RouterState } from "connected-react-router";
import { AgentGroup } from "../../shared/model/AgentGroup";
import { ITestProcess } from "../reducers/TestProcessReducer";
import { IElementDictionary, IProcessVariable, ISubProcessData, ITaskData } from "./IProcessData";
import { ITimeZoneEntry } from "./ITriggerData";
import { Process } from "./Process";
import { ValidationState } from "./ValidationData";

import { ISimpleApiSpecificationData } from "../../apiManagement/model/model";
import { UserSnippet } from "../actions/SnippetActions";

export class State {
    public process: Process;
    public uiState: UIState;
    public tasks: ITaskData[];
    public apiSpecs: ISimpleApiSpecificationData[];
    public subProcesses: ISubProcessData[];
    public timeZones: ITimeZoneEntry[];
    public elements: IElementDictionary;
    public environmentVariables: string[];
    public agentGroups: AgentGroup[];
    public validation: ValidationState;
    public testProcess: ITestProcess;
    public router: RouterState;
    public snippets: UserSnippet[];
    public processVariables: IProcessVariable[];
}
export interface UIState {
    disableEdit?: boolean;
    isLoading?: boolean;
    isSaving?: boolean;
    editorIsReady?: boolean;
    isDirty?: boolean;
    hasChanges?: boolean;
    parameterEditorModes?: { [parameterId: string]: string };
    isTestProcessFetching?: boolean;
    panelSettings: IPanelSettings;
    redirectAfterSaveTo?: string;
    showRunOnceDialog?: boolean;
    documentation?: IDocumentationState;
    isIntercomDocumentationEnabled?: boolean;
    tcpTriggerEnabled?: boolean;
    isEditorReadOnly?: boolean;
    isEditingTask?: boolean;
    dependencyConstraintsErrorMessage?: string | null;
    dmnChangeCount: number;
}

export enum PanelType {
    ElementPanel = "elementPanel",
    ProcessSidePanel = "processSidePanel",
    DocumentationPanel = "documentationPanel"
} 

export interface IPanelSettings {
    [PanelType.ElementPanel]: IElementPanelSettings;
    [PanelType.ProcessSidePanel]: IProcessPanelSetting;
    [PanelType.DocumentationPanel]: ISinglePanelSetting;
}

export interface ISinglePanelSetting {
    width: number;
    isOpen: boolean;
}

export interface IElementPanelSettings extends ISinglePanelSetting {
    selectedElementId: string | null;
}

export interface IProcessPanelSetting extends ISinglePanelSetting {
    selectedPanelType: ProcessSidePanelType;
    isPinned: boolean;
}

export enum ProcessSidePanelType {
    SettingsPanel,
    VariablesPanel,
    TestPanel,
    SnippetsPanel,
}

export interface IDocumentationState {
    type: "element" | "trigger",
    identifier: string
}